import React from "react"
import CircularProgress from "./../../components/CircularProgress";
import CustomBarChart from "./../../components/CustomBarChart";
import CustomLineChart from "./../../components/CustomLineChart";
import CustomSwitch from "./../../components/CustomSwitch";
import CustomTable from "./../../components/CustomTable";
import Indicator from "./../../components/Indicator";
import Divider from "./../../components/Divider";
import HorizontalBarChart from "./../../components/HorizontalBarChart";
import Footer from "./Footer";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import CustomSkeleton from "./Skeleton";


const PropertyTypePage = (props) => {
	const { name, title, type, reportData, searchTags, summarizeGeographies, priorYearPeriodName, currentPeriodName, customDate, color , AiResponse} = props;
	const { dateOptions, theme, style } = customDate;

	const hasLocation = searchTags && searchTags.length>0
	return (
	  <div className="report-container page-section">

		<section className="report-section">
		  <h3 className="header-text heading-location editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
		  <div className="header-subtext__heading editable">{type.name}</div>
		  <div className="subtext-grid">
			<div className="header-inner-subtext__heading editable">
			  {type.title}
			</div>
			<div>
			  <div >Date Range</div>
			  <div className="editable">{priorYearPeriodName} vs. {currentPeriodName}</div>
			</div>
		  </div>
	  
		  <div className="semi-progress-container">
			<div className="inner_heading_container">
			  <div >Contracts</div>
			  {/* component for semi circle */}
			  <CircularProgress value={(validateNestedData(
				  reportData,
				  `facets.${type.key}.contract_signed.current_period.count`
				) &&
				validateNestedData(
				  reportData,
				  `facets.${type.key}.contract_signed.prior_year_period.count`
				)
				  ? percentageChange(
					  reportData.facets[type.key].contract_signed.current_period
						.count,
					  reportData.facets[type.key].contract_signed.prior_year_period
						.count
					)
				  : "0")} />
			</div>
			<CustomSwitch
			  rows={[
				{
				  firstValue: "Volume",
				  middleValue: "",
				  lastValue: "Avg DOM",
				  header: true,
				},
				{
				  firstValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.current_period.count`)  ? _formatNumber(reportData.facets[type.key].contract_signed.current_period.count) : "--",
				  middleValue: currentPeriodName,
				  lastValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.current_period.dom.med`)  ? _formatNumber(reportData.facets[type.key].contract_signed.current_period.dom.med) + " Days" : "--",
				},
				{
				  firstValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.prior_year_period.count`)  ? _formatNumber(reportData.facets[type.key].contract_signed.prior_year_period.count) : "--",
				  middleValue: priorYearPeriodName,
				  lastValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.prior_year_period.dom.med`)  ? _formatNumber(reportData.facets[type.key].contract_signed.prior_year_period.dom.med) + " Days" : "--",
				},
			  ]}
			  hightlightedElement={1}
			
			/>
			<div className="inner_heading_container">
			  <div >Days on Market</div>
			  <div>
				<CircularProgress value={(validateNestedData(
				  reportData,
				  `facets.${type.key}.contract_signed.current_period.dom.med`
				) &&
				validateNestedData(
				  reportData,
				  `facets.${type.key}.contract_signed.prior_year_period.dom.med`
				)
				  ? percentageChange(
					  reportData.facets[type.key].contract_signed.current_period
						.dom.med,
					  reportData.facets[type.key].contract_signed.prior_year_period
						.dom.med
					)
				  : "0")} reverse={true} />
			  </div>
			</div>
		  </div>
		  <div className="report-layout-table-container">
			
			<CustomTable
			  headers={["PRICE RANGE", currentPeriodName, priorYearPeriodName, "% CHANGE"]}
			  rows={[
				["UNDER $1M", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.under_one.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.current_period.under_one.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.under_one.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.prior_year_period.under_one.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.under_one.count`
				  ) &&
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.under_one.count`
				  )
					? percentageChange(
						reportData.facets[type.key].contract_signed.current_period.under_one.count,
						reportData.facets[type.key].contract_signed.prior_year_period.under_one.count
					  ) + "%"
					: "--"],
				["$1M - $2M", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.one_to_two.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.current_period.one_to_two.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.one_to_two.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.prior_year_period.one_to_two.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.one_to_two.count`
				  ) &&
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.one_to_two.count`
				  )
					? percentageChange(
						reportData.facets[type.key].contract_signed.current_period.one_to_two.count,
						reportData.facets[type.key].contract_signed.prior_year_period.one_to_two.count
					  ) + "%"
					: "--"],
				["$2M - $4M", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.two_to_four.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.current_period.two_to_four.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.two_to_four.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.prior_year_period.two_to_four.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.two_to_four.count`
				  ) &&
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.two_to_four.count`
				  )
					? percentageChange(
						reportData.facets[type.key].contract_signed.current_period.two_to_four.count,
						reportData.facets[type.key].contract_signed.prior_year_period.two_to_four.count
					  ) + "%"
					: "--"],
				["$4M - $10M", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.four_to_ten.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.current_period.four_to_ten.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.four_to_ten.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.prior_year_period.four_to_ten.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.four_to_ten.count`
				  ) &&
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.four_to_ten.count`
				  )
					? percentageChange(
						reportData.facets[type.key].contract_signed.current_period.four_to_ten.count,
						reportData.facets[type.key].contract_signed.prior_year_period.four_to_ten.count
					  ) + "%"
					: "--"],
				["OVER $10M", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.ten_plus.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.current_period.ten_plus.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.ten_plus.count`
				  )
					? _formatNumber(
						reportData.facets[type.key].contract_signed.prior_year_period.ten_plus.count
					  )
					: "--", 
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.current_period.ten_plus.count`
				  ) &&
				  validateNestedData(
					reportData,
					`facets.${type.key}.contract_signed.prior_year_period.ten_plus.count`
				  )
					? percentageChange(
						reportData.facets[type.key].contract_signed.current_period.ten_plus.count,
						reportData.facets[type.key].contract_signed.prior_year_period.ten_plus.count
					  ) + "%"
					: "--"],
			  ]}
			  theme={theme}
			  color={color}
			/>


			<div className="table-side-container">
			  <p className="editable">
				
				{AiResponse && AiResponse[type.key] && AiResponse[type.key].contracts_signed? AiResponse[type.key].contracts_signed:<CustomSkeleton count={12}/>}
			  </p>
	  
			  
			</div>
		  </div>
		</section>
		<Divider theme={theme} />
		<section className="report-section">
		  <div className="custom-charts">
			<div className="indicator-container">
			  <div className="heading" >CLOSINGS</div>
			  <Indicator
				price={validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.med_price`)  ? _formatPrice(reportData.facets[type.key].recorded_sold.current_period.med_price) : "--"}
				percentage={validateNestedData(
					reportData,
					`facets.${type.key}.recorded_sold.current_period.med_price`
				  )
					? percentageChange(
						reportData.facets[type.key].recorded_sold.current_period
						  .med_price,
						reportData.facets[type.key].recorded_sold.prior_year_period
						  .med_price
					  )
					: "--"}
				reverse={true}
				name="Med Price"
			  />
			  <Indicator
				price={validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.ppsf.med`)  ? _formatPrice(reportData.facets[type.key].recorded_sold.current_period.ppsf.med) : "--"}
				percentage={validateNestedData(
					reportData,
					`facets.${type.key}.recorded_sold.current_period.ppsf.med`
				  ) && validateNestedData(
					  reportData,
					  `facets.${type.key}.recorded_sold.prior_year_period.ppsf.med`
					)
					? percentageChange(
						reportData.facets[type.key].recorded_sold.current_period
						  .ppsf.med,
						reportData.facets[type.key].recorded_sold.prior_year_period
						  .ppsf.med
					  )
					: "--"}
				reverse={true}
				name="Price S/F"
	
			  />
			</div>
			<div className="chart_wrapper">
			  <div className="subtext editable">
				  {AiResponse && AiResponse[type.key] && AiResponse[type.key].recorded_sales ? AiResponse[type.key].recorded_sales:<CustomSkeleton count={4}/>}
			  </div>
			  <div className="chart_inner">
				<div className={`Chart-1 ${hasLocation ? "Has-Loc" : ""}`}>
				  <div className="heading" >MEDIAN PRICE / SF</div>
				  <CustomLineChart
					theme={theme}
					data={reportData.facets[type.key].recorded_sold.chart.buckets.slice(reportData.facets[type.key].recorded_sold.chart.buckets.length - 12,reportData.facets[type.key].recorded_sold.chart.buckets.length).map(item => ({year : formatDateRange(null, null, item.val), price: item.ppsf && item.ppsf.med ? Math.round(item.ppsf.med) : 0}))}
				isWeekly={dateOptions.gap}
				/>
				  
				</div>
				{(!hasLocation) ?
				<div className="Chart-2">
				  <div className="heading" >MEDIAN PRICE</div>
				  <CustomBarChart
					theme={theme}
					data={[
					  { name: "MN", value: validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.by_borough.buckets`) && reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "manhattan")[0]  ? (reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "manhattan")[0].med_price) : 0 },
					  { name: "BK", value: validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.by_borough.buckets`) && reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "brooklyn")[0]  ? (reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "brooklyn")[0].med_price) : "--" },
					  { name: "QN", value: validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.by_borough.buckets`) && reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "queens")[0]  ? (reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "queens")[0].med_price) : 0 },
					]}
					isWeekly={dateOptions.gap}
				  />
				</div>:null}
			  </div>
			</div>
		  </div>
		</section>
		<Footer />
	  </div>
	)
  }
  
  export default PropertyTypePage;
